/**
 * Created by mauget on 3/1/16.
 */

import $ from 'jquery';
import Base64Encoder        from 'util/Base64Encoder.js';
import { View }             from 'backbone';
import { Model }            from 'backbone';
import _                    from 'lodash';
import restService          from 'RestService';
import eventBus             from 'EventBus.js';
import constants            from 'Constants';
import contentTemplate      from 'dashboard/forms/form-details-view.ejs';
import formLoadService      from 'FormLoadService.js';
import notificationService  from 'NotificationService';
import DeleteModal          from 'dashboard/forms/modal/FormDeleteModal.js';
import CreateFormInstanceModal from 'dashboard/forms/modal/CreateFormInstanceModal.js';
import ConfirmationModal    from 'dashboard/forms/modal/ConfirmationModal';
import MobileConfirmationModal    from 'dashboard/forms/modal/MobileConfirmationModal';
import SelectItemModalView  from 'common-views/SelectItemModalView.js'
import LinkModal            from 'dashboard/LinkModal.js';
import SelectFileModal      from 'common-views/SelectFileModal.js';
import MigrateFormModal     from 'dashboard/forms/modal/MigrateFormModal.js';
import PlayFormModal        from 'common-views/PlayFormModal.js';
import AlertDialogView      from 'common-views/AlertDialogView.js';
import util                 from 'util/Util.js';
import listService          from 'ListService.js';
import mobileListService    from 'mobile/MobileListService';
import undoService          from 'UndoService.js'
import textConstants        from 'TextConstants';
import restMessages         from "RestMessages";
import configService        from 'ConfigService';
import PermissionsDetailView from 'dashboard/forms/PermissionsDetailView';
import SimpleConfirmModalView from "common-views/SimpleConfirmModalView.js";
import restServiceAux       from "RestServiceAux";
import userService from "UserService.js";
import mobileConstants from "../../../mobile/commons/MobileFormsConstants";
import Spinner from 'spin/spin';

import leftPanelState       from "LeftPanelStateService";
import RecoverDesignModal from './modal/RecoverDesignModal';

class FormDetailsView extends View {

    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;
        this.Spinner = new Spinner();

        $(this.el).off('click');
        configService.promise.then(config => {
            this.apiHostUrl = config.apiHostUrl;
            this.hostUrl = config.hostUrl;
        });

        this.permsSelector = `select[name='permissions']`;
        this.model.set('selectedViewer', '', {silent:true});
        this.model.set('selectedViewerId', '', {silent:true});
        this.events = {
            'click #migrateForm' : 'migrateForm',
            'keyup input[name="currentFormName"]': 'changeTextInputField',
            'change input[type="text"]': 'changeTextInputField',
            'change input[name="currentIsActive"], input[name="currentRequireLoginFromEmail"], input[name="mobileFormIsActive"]' : 'changeCheckboxes',
            'change input[name="version"]': 'changeVersion',
            'change #draftVersion, #publishedVersion' : 'selectVersion',
            'click #designForm': 'design',
            'click #linkForm': 'linkForm',
            'click #newInstanceForm': 'createNewInstance',
            'click #publishForm': 'confirmRecoverDesign',
            'click #shareForm': 'shareForm',
            'click #deleteForm': 'deleteForm',
            'click #addPermissionForm': 'addPermission',
            'click #removePermissionForm': 'removePermission',
            'click #applyChangesForm': 'applyChanges',
            'click a.item-link' : 'handleSelectedItem',
            'click #cancelChangesForm': 'cancelChanges',
            'click #lstFrmDetInstances span.detFormInstance' : 'loadViewByInst', 
            'click #goToForms': 'goToForms',
            'click #goToEditForms': 'goToEditForms'
        };

        if (this.model.get('hasChanges') === undefined) {
            this.model.set('hasChanges', false);
        }

        if (this.model.get('formName') === undefined) {
            this.model.set('formName', '');
        }

        if (this.model.get('isActive') === undefined) {
            this.model.set('isActive', true, {silent: true});
        }

        if (this.model.get('requireLoginFromEmail') === undefined) {
            this.model.set('requireLoginFromEmail', true, {silent: true});
        }

        this.model.set('isMobileDevice', util.isMobileDevice(), constants.MODEL_SILENT);
        this.model.set('mobileMessage', constants.MESSAGE_DASHBOARD_ONMOBILE, constants.MODEL_SILENT);

        this.setMobileValues();

        this.model.set('currentViewerPerms', {}, {silent: true});
        this.model.set('isReport', false, {silent: true});
        this.model.set('isShared', !util.isTrue(this.model.get('IsPrivate')), {silent: true});
        this.listenTo(this.model, 'change', this.render);
        this.listenTo(eventBus, 'applyNameFormChanges', this.applyFormNameOnTree);

        return this;
    }

    setMobileValues(){
        const mobileEnabledAccount = userService.checkFeatures(mobileConstants.MOBILE_ACCOUNT_VIEW);
        this.model.set('mobileFeatureIsEnabled', mobileEnabledAccount, constants.MODEL_SILENT);

        const formIsActive = this.model.get('currentIsActive');
        const mobileWizardIsCompleted = this.model.get('mobileWizardIsCompleted');

        const mobileCheckbox = this.model.get('mobileFormIsActive');
        this.model.set('mobileFormIsActive', mobileCheckbox, constants.MODEL_SILENT);

        let mobileFormIsEnabled = mobileEnabledAccount && formIsActive && mobileWizardIsCompleted;
        this.model.set('mobileFormIsEnabled', mobileFormIsEnabled, constants.MODEL_SILENT);
    }

    loadViewByInst(ev){
        eventBus.trigger('loadViewByInstance', ev);
    }

    applyFormNameOnTree(id, groupType, text) {
        let formElement = $(`a[data-itemid="${groupType}_${id}"]`);
        if (formElement) {
            formElement.text(text).attr('title', text);
        }        
    }

    applyChanges() {
        PermissionsDetailView.validateChanges(
            util.isTrue(this.model.get('IsPrivate')),
            this.model.get('currentPermissionList'),
            this.applyChangesAction, this);
    }

    applyChangesAction() {

        const formId = this.model.get('formId');
        const groupId = this.model.get('GroupId');
        const groupType = this.model.get('groupType');

        const currentFormName = this.model.get('currentFormName');
        const currentIsActive = this.model.get('currentIsActive');
        const currentNotificationRequiresLogin = this.model.get('currentRequireLoginFromEmail');

        const currentPermissionList = this.model.get('currentPermissionList');
         // console.log('Current Permissions', currentPermissionList);

        const currentPermissionsToSend = FormDetailsView.formatPermissionsForResponse(currentPermissionList);
         // console.log('Current Permissions to send', currentPermissionsToSend);


        const formName = this.model.get('formName');
        const isActive = this.model.get('isActive');
        const mobileFormIsActive = this.model.get('mobileFormIsActive');
        const notificationRequiresLogin = this.model.get('notificationRequiresLogin');

        const permissionList = this.model.get('permissionList');
        const permissionsToSend = permissionList ? FormDetailsView.formatPermissionsForResponse(permissionList) : null;

        undoService.add({
            undo: () => {
                this.persistData({
                    formId:formId,
                    formName:formName,
                    isActive:isActive,
                    mobileEnabled: mobileFormIsActive,
                    notificationRequiresLogin:notificationRequiresLogin,
                    permissionsToSend:permissionsToSend,
                    groupType: groupType,
                    groupId: groupId
                });
            },
            redo: () => {
                this.persistData({
                    formId:formId,
                    formName:currentFormName,
                    isActive:currentIsActive,
                    mobileEnabled: mobileFormIsActive,
                    notificationRequiresLogin:currentNotificationRequiresLogin,
                    permissionsToSend:currentPermissionsToSend,
                    groupType: groupType,
                    groupId: groupId
                });               
            }
        }, textConstants.UNDO_UPDATE_FORM);

        this.persistData({
            formId:formId,
            formName:currentFormName,
            isActive:currentIsActive,
            MobileEnabled: mobileFormIsActive,
            notificationRequiresLogin:currentNotificationRequiresLogin,
            permissionsToSend:currentPermissionsToSend,
            groupType: groupType,
            groupId: groupId
        });
    }

    persistData(opts){
        // Saving Changes made on the form.
        restService.updateForm(opts.formId, opts.formName, opts.isActive, opts.MobileEnabled, opts.notificationRequiresLogin, opts.permissionsToSend).then(data => {
            // console.log('updated Form');
            // console.log(data);
            eventBus.trigger(constants.EV_UPDATE_FORM_DETAILS,opts.formId,opts.groupType,opts.groupId);
            eventBus.trigger('applyNameFormChanges', opts.formId, opts.groupType, opts.formName);
        },  err => {
            console.log(`persistData upDateForm: ${restMessages.codeToMessage(err.CODE)}`);
        })
    }


    cancelChanges(){

        // console.log("Model before",this.model);
        this.model.set('currentFormName',this.model.get('formName'),{silent:true});
        this.model.set('currentIsActive',this.model.get('isActive'),{silent:true});
        this.model.set('mobileFormIsActive', !this.model.get('mobileFormIsActive'),{silent:true});
        this.model.set('currentRequireLoginFromEmail',this.model.get('requireLoginFromEmail'),{silent:true});

        this.model.set('currentPermissionList', _.cloneDeep(this.model.get('permissionList')),{silent:true});

        this.model.set('hasChanges', false,{silent:false});

        window.setTimeout( () => $(this.permsSelector).trigger('change'), 0);
        window.setTimeout( () => PermissionsDetailView.clearPermPanel(constants.FORMS_PERMISSION_ITEM_COUNT), 0);

        console.log(`cancel current perms`, this.model.get('currentPermissionList'));
        console.log(`cancel perms`, this.model.get('currentPermissionList'));
    }

    // Called by ReportDetailsView.formatPermissionsForResponse(permissions)
    // Note that ActionService has a method like this, but it appears to be in error -- handles only one permission item.
    static formatPermissionsForResponse(permissions) {

        let isNoUsers = false;
        const bufferStr = permissions.reduce((accum, elem) => {

            const defaultId = (!(elem['@type'] === 'world' || elem['@type'] === 'everyone'))
                ? ` id="${elem['@id']}" `
                : ` id="-2147483524" `;

            let perms = accum + `<User ${defaultId} type="${elem['@type']}"  caption="${elem['@caption']}"> `;

            // Notice that each Permission value is emitted as the Permission XML element value, not an XML attribute
            util.enforceArrayType(elem.Permission).forEach(p => {
                if (p) {
                    perms += `<Permission type="${p['@type']}">${p['#text']}</Permission>`;
                } else {
                    isNoUsers = true;
                }

            });

            if (!isNoUsers) {
                perms += `</User>`;
            }
            return perms;

        }, '');

        const noUsers = `<Permissions><User  id="-2147483524"  type="world"  caption="World"> <Permission type="view">deny</Permission></User></Permissions>`;

        const permissionList = isNoUsers ? noUsers : `<Permissions>${bufferStr}</Permissions>`;

        console.log('CurrentSendPermissions before encoding', permissionList);

        const encodedPermissionList = permissionList.replace(/</g, '&lt;').replace(/>/g, '&gt;');

        return encodedPermissionList;
    }

    addPermission(ev) {
        ev.preventDefault();
        //Add timeout to allow the spinner to show
        this.Spinner.spin($(constants.CONTENT_ID).get(0));
        setTimeout( () => {
            restService.browseAllUsers().then(usersData => {
                 console.log("The users data", usersData);
    
                const users = ( ud => {
                    let userAccum = [];
                    userAccum.push( PermissionsDetailView.createUserSpecialItem('World') );
                    userAccum.push( PermissionsDetailView.createUserSpecialItem('Everyone') );
    
                    if (ud.AllUsers.User) {
                        userAccum = _.union(userAccum, util.enforceArrayType(usersData.AllUsers.User));
                    }
                    return userAccum;
                })(usersData);
    
                // console.log("new users", users);
                const items = users.map( item => {
                    return {
                        id: item['@id'],
                        label: item['@caption'],
                        listType: item['@type'],
                        items: item
                    }
                });
                
                const isReport =  false;
    
                // PF-5852 added param infiniteScrolling to allow list to use it
                const permissionView = new SelectItemModalView({ model: new Model({items: items, width: 375, infiniteScrolling: constants.INFINITE_SCROLL_ENABLED}), spinner: this.Spinner });
                   
              permissionView.render().then(selectedItem => {
                  
                     if (selectedItem) {
                        // console.log('Added Permission Forms', selectedItem);
    
                        // Checking if the permission selected is not already present in the current list.
                        // (Note the World and Everyone have identical IDs. Hence the looser comparison)
                        const currentPermissionList = this.model.get('currentPermissionList');
                        const permissionsChanged = currentPermissionList.filter((permission)=> {
                            return permission['@id'] === selectedItem.items['@id']
                                && permission['@caption'] === selectedItem.items['@caption'];
                        });
    
                        if (permissionsChanged.length === 0) {
    
                            const newItem = _.cloneDeep( PermissionsDetailView.createPermissionForItem( selectedItem, isReport ));
                            currentPermissionList.push(newItem);
    
                            this.model.set(
                                {
                                    'hasChanges': true,
                                    'currentPermissionList': currentPermissionList
                                }, {silent: false});
    
                            // This second triggers, deep change
                            this.model.trigger('change', this.model);
                            const
                                viewerId = selectedItem.items['@id'],
                                viewerName = selectedItem.items['@caption'];
                            PermissionsDetailView.selectPermissionViewer( viewerId, viewerName );
    
                        }

                        
                    }
            
                }).catch((errMsg) => {
                    console.log(errMsg);
                    notificationService.error(errMsg);
                });
            });
        }, 100);
        
    }

    removePermission(ev){
        ev.preventDefault();
        const
            $row = $(`select[name='permissions']`),
            selectedUser = $row.val(),
            selectedUserId = $row.children(':selected').attr('id'),
            isWorldOrEveryone = 'World' === selectedUser || 'Everyone' === selectedUser;

        const currentPermissionList = this.model.get('currentPermissionList');
        const currentPermissionListWithRemovedElement = currentPermissionList.filter( user => isWorldOrEveryone
                ? user['@caption'] !== selectedUser
                : user['@id'] !== selectedUserId  );

        if(currentPermissionListWithRemovedElement.length < currentPermissionList.length) {

            this.model.set(
                {
                    'hasChanges': true, 'currentPermissionList': currentPermissionListWithRemovedElement,
                    'selectedViewer': '',
                    'selectedViewerId': ''
                }, {silent: true});
            this.model.trigger('change', this.model, {silent: false});
            this.render();

            window.setTimeout( () => PermissionsDetailView.clearPermPanel(constants.FORMS_PERMISSION_ITEM_COUNT), 0);
        }
    }


    changeCheckboxes(event) {
        const name = event.target.name;
        const value = event.target.checked;
        this.model.set(name, value, {silent: true});
        this.model.set('hasChanges', true, {silent: false});
    }


    // Note: caught for ANY text field change, so filter 'em:
    changeTextInputField(event) {
        const target = event.currentTarget;
        const name = target.name;
        const value = target.value;

        // PF-5944 Validate if value actually changed (for keyup event)
        let previousValue = this.model.get(name);

        if (previousValue !== value) {
            this.model.set(name, value, {silent: true});
            this.model.set('hasChanges', true, {silent: true});

            // Show apply changes
            $('#formActionSection').addClass('hide');
            $('#formPermissionSection').removeClass('hide');
        }
    }

    // PF-4409
    // Called when any of three version radiobuttons selection changed
    changeVersion(event) {
        const name = event.target.name;
        const value = event.target.value;

        this.model.set(name, value, {silent: true});

        $('#publishedVersion').prop('disabled', value !== 'published');
        $('#draftVersion').prop('disabled', value !== 'draft');

        $('#publishForm').prop('disabled', true);
        $('#linkForm').prop('disabled', true);


        if(value === 'published'){
            const publishNumVersion = $('#publishedVersion').val();
            this.model.set('publishedVersion', publishNumVersion, {silent: true});
            $('#publishForm').prop('disabled', true);
            $('#linkForm').prop('disabled', false);

        } else if(value === 'draft'){
            const latestVersion = $('#latestVersion').text();
            const draftNumVersion = $('#draftVersion').val();
            this.model.set('draftVersion', draftNumVersion, {silent: true});            
            $('#publishForm').prop('disabled', draftNumVersion !== latestVersion);
            $('#linkForm').prop('disabled', true);
        }
        // PF-4409 - Manage buttons for "latest"
        else if(value === 'latest'){
            // Module value 'deployedVersion' is not useful here. It is the currently selected published item,
            // which may not be the latest deployed/published version. The #latestPublished DOM text item is stable.
            const latestPublished = $('#latestPublished').text();
            const draftNumVersion = $('#draftVersion').val();
            const hasDraft = !latestPublished || draftNumVersion;
            const latestVersion = $('#latestVersion').text();
            const versionSplit = latestVersion.split('.');
            const isFinalVersion = versionSplit.length === 2 && parseInt(versionSplit[1]) === 0;
            $('#publishForm').prop('disabled', isFinalVersion);
            $('#linkForm').prop('disabled', !(latestPublished || hasDraft));
        }
    }

    //===============================================================================
    // Carries out a linear probe ot versionList for a member having a form ID that
    // matches the form ID held by versionInfo.
    //
    // Returns the sequential index of that member.
    //===============================================================================
    findVersionIndex(versionList, versionInfo) {
        let index = 0;
        _.forEach(versionList, (item, k) => {
            if (item['@FormVersionId'] === versionInfo.formVersionId) {
                index = k;
                return k;
            }
        });
        return index;
    }

    design(ev) {
        const formId = this.model.get('formId');
        const formLinkId = this.model.get('LinkId');
        const versionList = this.model.get('versionList');
        const fName = this.model.get('formName');

        const versionInfo = this.getSelectedVersionId();
        const listIndex = this.findVersionIndex( versionList, versionInfo );

        const majorVersion = versionList instanceof Array ? versionList[listIndex]['@MajorVersion'] : versionList['@MajorVersion'];
        const minorVersion = versionList instanceof Array ? versionList[listIndex]['@MinorVersion'] : versionList['@MinorVersion'];
        const lastUpdateDate = this.model.get("lastUpdateUTC");

        util.setPanelDefaults();

        // Preload connections
        restService.getConnections().then((connections)=> {
            window.sessionStorage.setItem('pfConnections', JSON.stringify(connections));
        }).then(()=>{
            formLoadService.loadForm( formId, majorVersion, minorVersion, formLinkId, fName, versionInfo.formVersionId, lastUpdateDate ).then( msg =>{
                listService.dashboardLayout.leftPanelView.remove();
                listService.dashboardLayout.mainPanelView.remove();

                util.openHelpCenter(constants.KIND_LAYOUT);

                leftPanelState.save();
                //notificationService.success( msg );
            }, ( errMsg ) =>{
                if(errMsg.toString().trim() === restMessages.getTextEditedByOtherUser()){
                    util.showAlert(textConstants.EDITOR_DESIGN, textConstants.EDITOR_DESIGN_OPENED_BY_OTHER_USER, 150);
                }else{
                    notificationService.error( errMsg );
                }
            });
        }, ( errMsg ) =>{
            notificationService.error( errMsg );
        });
    }

    deleteForm(ev) {
        ev.preventDefault();
        const formId = this.model.get('formId');
        const formName = this.model.get('formName');
        const groupId = this.model.get('GroupId');
        const groupType = this.model.get('groupType');
        const formLink = this.model.get('LinkId');
        const versionList = this.model.get('versionList');
        const totalOpenInstances = this.model.get('totalOpenInstances');
        let element;
        if(this.model.get('totalInstances') > 0){
            element=$(`a[data-linkid=${this.model.get('LinkId')}]`).parent().first().prop('outerHTML');
            element+=$(`a[data-linkid=${this.model.get('LinkId')}]`).parent().first().next().prop('outerHTML');
        }

        const deleteModal = new DeleteModal({
            model: new Model({
                formName: formName, formId: formId, formLink: formLink,
                versionList: versionList, totalOpenInstances: totalOpenInstances,
                groupId: groupId, groupType:groupType,elementToAttach:element,
                hasMobileForm: !this.model.get('mobileFeatureIsEnabled') || (this.model.get('mobileFeatureIsEnabled') && !this.model.get('mobileFormIsActive'))
            }), 
            width: 470, height: 410
        });
        deleteModal.render().then( result => {
            console.log(result);
        }, err => console.log(`deleteForm rejection:`, err)).catch(err => console.log(err));
    }

    // PF-4409 Helper used to manage states that drive Publish, New Instance and Link buttons
    getSelectedVersionId() {
        const versionList = util.enforceArrayType(this.model.get('versionList'));
        let formVersionId;
        let isDraft = false;
        // PF-5014 validate if is the latest version published
        let isLatest = true;
        let versionNumber = 'latest';
        const opt = $('input[name=version]:checked');

        if (opt[0].value === 'latest') {
            formVersionId = versionList[0]['@FormVersionId'];
            if ($('select[name=draftVersion] option').length > 0 && !util.isTrue(this.model.get('IsDeployed'))){
                isDraft = true;
            }
        }

        else if (opt[0].value === 'published') {
            const selectedVersion = $('select[name=publishedVersion] option:checked');
            formVersionId = selectedVersion.attr('formVersionId');
            isLatest = false;
            versionNumber = selectedVersion.val();
        }

        else if (opt[0].value === 'draft') {
            const selectedVersion = $('select[name=draftVersion] option:checked');
            formVersionId = selectedVersion.attr('formVersionId');
            isDraft = true;
            isLatest = false;
            versionNumber = selectedVersion.val();
        }

        return {formVersionId: formVersionId, isDraft: isDraft, isLatest: isLatest, versionNumber: versionNumber};
    }

    createNewInstance(ev) {
        // if Latest is chosen, then find the Version in the list match [version], use the FormVersionId
        // if publish or draft is selected, use the select option [FormVersionId]
        const versionInfo = this.getSelectedVersionId();
        // PF-5014 validate version selected to open new instance
        let url = '';
        if (!versionInfo.isLatest && !versionInfo.isDraft) {
            url = versionInfo.formVersionId + '&viewForm=true' + listService.isSSO();
        } else {
            url = this.model.get('LinkId') + '&viewForm=true' + listService.isSSO();
        }

        if (versionInfo.isDraft) {
            const newDraft = new CreateFormInstanceModal({model: new Model() });
            newDraft.render().then((result) => {
                this.playForm(url, versionInfo, (result.toLowerCase() === 'yes'));
            }).catch(e => {
        
            });
        
        } else {
            this.playForm(url, versionInfo, false);
        }
    }

    playForm(id, versionInfo, redirectNotifications) {
        let instanceUrl;
        if (!versionInfo.isDraft){
          instanceUrl = this.hostUrl + '/player.htm?f=' +  id;
        }else{
            instanceUrl =  restService.getNewInstanceDraftLink() + "&isDraft=1&linkId=" + id + "&formVersionId=" + versionInfo.formVersionId;
            instanceUrl = instanceUrl.replace("{0}",this.model.get('formId'));
        }

        if (redirectNotifications){
            instanceUrl += '&redirectNotifications=true';
        }
        
        const attributes = {url: instanceUrl, id: id };
        const newPlayForm = new PlayFormModal({model: new Model(attributes) });
        let formId=this.model.get('formId');
        newPlayForm.render().then((result) => {
            eventBus.trigger('newInstance', formId);
        });
    }

    createNewInstanceForm(formVersionId, formId) {
        
        let linkUrl = restService.getLinkUrl(formVersionId);
        const attributes = {url: linkUrl, id: formVersionId };

        const newPlayForm = new PlayFormModal({model: new Model(attributes) });
        newPlayForm.render().then((result) => {

        });
    }

    linkForm(ev) {
        // PF-9553 Validate if is a trial account
        let isTrial = this.model.get('isTrial');
       
        let formId = this.model.get('formId');
        let formName = this.model.get('formName');
        const width = this.model.get('Width');
        const height = this.model.get('Height');
        let formLink = this.model.get('LinkId');
        const apiReference = this.model.get('apiReference');
        const hostUrl = this.hostUrl;  

        const versionInfo = this.getSelectedVersionId();
        // PF-5014 validate version selected to open new instance
        if (!versionInfo.isLatest) {
            formLink = versionInfo.formVersionId;
        }

        var linkModal = new LinkModal({
            model: new Model({ hostUrl: hostUrl,
                name: formName, id: Base64Encoder.encodeToString(formId), link: formLink,
                width: width, height: height, apiReference: apiReference, versionInfo: versionInfo
            })
        });
        linkModal.render().then((result)=> {
            console.log(result);
        });              
    }

    newInstance(ev) {
        //  check if the modal is gonna be displayed
        let formId = this.model.get('formId');
        let formName = this.model.get('formName');
        if (this.model.get('versionList') instanceof Array ||
            (this.model.get('versionList')['@MajorVersion'] !== '0' && this.model.get('versionList')['@MajorVersion'] !== 0)) {
            //  TODO create and display the new instance in a modal
            console.log('create new instance')
        } else {
            //  TODO:  create the modal
            console.log('display the modal')
        }
    }

    checkMobileStatus(){
        const mobileFeatureIsEnable = this.model.get('mobileFeatureIsEnabled');
            const mobileFormIsEnabled = this.model.get('mobileFormIsEnabled');
            const mobileFormIsActive = this.model.get('mobileFormIsActive');
            const mobileDesignExists = this.model.get('mobileDesignExists');
            const mobileWizardIsCompleted = this.model.get('mobileWizardIsCompleted');
            const reflowEnabled = this.model.get('reflowEnabled');
    
            let confirmation;
    
            if(mobileDesignExists){
    
                if(mobileFormIsEnabled && !mobileFormIsActive){

                    if(!reflowEnabled){
                        confirmation = {
                                    height: 150,
                                    confirmationTitle: 'Publish App',
                                    confirmationText: `<div class="row">
                                                            <div class="col-sm-12">            
                                                                <p> ${mobileConstants.PUBLISH_FORM_ACTIVATE_MOBILE_MESSAGE_TEXT} </p>
                                                            </div>
                                                        </div>`,
                                    buttons : [
                                                {
                                                    text: 'Activate Mobile',
                                                    resolve: "activateMobile"
                                                },
                                                {
                                                    text: "Don't Activate",
                                                    resolve: "dontActivateMobile"
                                                }]
                                    }
                    }
                    else{
                        confirmation = {
                            confirmationTitle: 'Publish App',
                            confirmationText: `<div class="row">
                                                    <div class="col-sm-12">            
                                                        <p> ${mobileConstants.PUBLISH_FORM_ACTIVATE_MOBILE_REFLOW_MESSAGE_TEXT} </p>
                                                    </div>
                                                </div>`,
                            buttons : [
                                        {
                                            text: 'Activate Mobile',
                                            resolve: "activateMobile"
                                        },
                                        {
                                            text: "Edit App Properties",
                                            resolve: "editApp"
                                        },
                                        {
                                            text: 'Cancel',
                                            resolve: "cancel"
                                        }]
                            }
                        }
                }
                else if(mobileFeatureIsEnable && !mobileWizardIsCompleted && mobileFormIsActive){

                    if(!reflowEnabled){
                        confirmation = {
                                    confirmationTitle: 'Publish App',
                                    confirmationText: `<div class="row">
                                            <div class="col-sm-12">            
                                                <p> ${mobileConstants.PUBLISH_FORM_MOBILE_INCOMPLETE_MESSAGE_TEXT} </p>
                                            </div>
                                        </div>`,
                                    buttons : [
                                                {
                                                    text: 'Publish Desktop',
                                                    resolve: "publish"
                                                },
                                                {
                                                    text: 'Edit Mobile App',
                                                    resolve: "edit"
                                                },
                                                {
                                                    text: 'Cancel',
                                                    resolve: "cancel"
                                                }]
                                    }
                    }
                    else{
                        confirmation = {
                            confirmationTitle: 'Publish App',
                            confirmationText: `<div class="row">
                                    <div class="col-sm-12">            
                                        <p> ${mobileConstants.PUBLISH_FORM_MOBILE_INCOMPLETE_REFLOW_MESSAGE_TEXT} </p>
                                    </div>
                                </div>`,
                            buttons : [                                       
                                        {
                                            text: 'Edit Mobile App',
                                            resolve: "edit"
                                        },
                                        {
                                            text: 'Cancel',
                                            resolve: "cancel"
                                        }]
                            }

                    }
                }
            }
    
            return confirmation;
    }

    confirmPublishWithMobileForm(e){
        let confirmation = this.checkMobileStatus();
        mobileListService.mobileAutoOpenWizard = false;

        if(confirmation){
            new MobileConfirmationModal( {
                model: new Model( {
                    confirmationTitle: confirmation.confirmationTitle,
                    confirmationText: confirmation.confirmationText,
                    height: confirmation.height,
                    width: 500,
                    buttons: confirmation.buttons
                })
            }).render().then(result => {
                if ('publish' === result) {
                    this.confirmPublishForm(e);
                }else if('edit' === result || 'editApp' === result){

                    if('edit' === result){
                        mobileListService.mobileAutoOpenWizard = true;
                    }
                    
                    this.design();
                }else if('activateMobile' === result){                   
                    this.model.set('mobileFormIsActive', true, constants.MODEL_SILENT);
                    this.applyChangesAction();
                    setTimeout(() => {
                        this.confirmPublishForm(e);
                    }, 500);                      
                }
                else if('dontActivateMobile' === result){
                        this.confirmPublishForm(e);
                }
            });
        }
        else{
            this.confirmPublishForm(e);
        }
    }

    confirmRecoverDesign(e) {
        const LastRecoveryUpdateDate = this.model.get('LastRecoveryUpdateDate');
        if (!util.isEmpty(LastRecoveryUpdateDate)) {
            const recoverDate = util.formatUTC(LastRecoveryUpdateDate);
            const formId = this.model.get("formId");
            const version = this.model.get("latestVersion").split(".");
            const lastUpdate = this.model.get("lastUpdateUTC");
            const recoverDesignModal = new RecoverDesignModal({ model: new Model({ formId: formId, recoverDate: recoverDate, fromAction: "publish", lastUpdate:  lastUpdate }) });

            recoverDesignModal.render().then(result => {
                if (result === "recover") {
                    restService.openForm(formId, version[0], version[1], true).then(data2 => {
                        restService.getFormDetails(formId).then((formDetailsResult) => {
                            this.model.set('versionList', formDetailsResult.RESULT.RESPONSE.PrivateFormDetails.VersionList.Version, {silent: true});
                            this.model.set('latestVersion', formDetailsResult.RESULT.RESPONSE.PrivateFormDetails.Version, {silent: true});
                            $("#designForm").trigger("click");
                        });
                    });
                } else if (result === "publish") {
                    this.confirmPublishWithMobileForm();
                }
            });
        }
        else{
            this.confirmPublishWithMobileForm();
        }
    }

    confirmPublishForm(e) {
        if ( util.isTrue(this.model.get('responsive')) && util.isTrue(this.model.get('containsMobileErrors')) ) {

            const
                alertText = 'Design elements are currently placed outside of the mobile canvas. Apps cannot be published until layout issues are resolved.',
                alertTitle = 'Layout issues',
                alertView = new AlertDialogView({model: new Model({text: alertText, title: alertTitle})});

            alertView.render();

        } else {
            const LastRecoveryUpdateDate = this.model.get('LastRecoveryUpdateDate');
            if ( this.model.get('publishedVersion') && util.isEmpty(LastRecoveryUpdateDate)) {  // Not first time publishing
                const
                    confirmationTitle = 'Publish App',
                    confirmationText =
                        '<div class="row">' +
                        '  <div class="col-sm-12">' +
                        '    <p> Are you sure you want to publish a new version of the app? </p>'+
                        '    <p> This will replace your previously published version as the one which is shown by default for a new instance.</p>' +
                        '  </div>' +
                        '</div>';

                    new ConfirmationModal( {
                    model: new Model( {
                        confirmationTitle: confirmationTitle,
                        confirmationText: confirmationText,
                        height: 196,
                        width: 500
                    })
                }).render().then(result => {
                    if ('Yes' === result) {
                        this.publishForm();
                    }
                });
            } else {
                // First time publishing
                this.publishForm();
            }
        }
    }

    publishForm() {
        let formId = this.model.get('formId');
        restService.deployForm(formId).then((data) => {
            if (data.fieldsWithChangedDataType){
                let changedData = data.fieldsWithChangedDataType.field;
                changedData = changedData instanceof Array? changedData : [changedData];
                let items = '<br/>';

                changedData.forEach( item => {
                  items += item['@name'] + '<br/>';
                });
                let message = '  <div class="col-md-12">' +
                        '    Publishing the new version of the app resulted in the following fields having changed their data-type: <br/>'+
                        items + '<br/>' +
                        '    This can have unexpected effects in reports which refer to this fields. It is recommended that you verify all reports which use these fields, and if necessary re-fresh the corresponding data-sources in the reports.'+
                        '</div>';

                let simpleModal = new SimpleConfirmModalView({
                    model:new Model({
                        subtitle: 'Publish App',
                        confirmationText: message,
                        width: 500,
                        showCancel: false
                    })
                });

                simpleModal.render();
            }
            var groupType = this.model.get('groupType');
            var groupId = this.model.get('groupId');

            eventBus.trigger('deployForm', formId, groupType, groupId);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            console.log('error ', error);
            notificationService.error(msg);
            return (error);
        });
    }


    shareForm(ev) {
        let params = {
            isPrivate: !util.isTrue(this.model.get('IsPrivate')),
            formId: this.model.get('formId'),
            groupId: constants.DEFAULT_GROUP_ID,
            name: constants.DEFAULT_GROUP_ID,
            groupType:this.model.get('groupType'),
            itemId: this.model.get('GroupId')
        };

        this.shareFormAPICall(params).then((results) => {

            undoService.add({
                undo:() => {
                    params.groupId = this.model.get('sharedGroupId');
                    params.isPrivate = true;
                    this.shareFormAPICall(params)
                },
                redo:() => {
                    params.groupId = constants.DEFAULT_GROUP_ID;
                    params.isPrivate = false;
                    this.shareFormAPICall(params)
                }
            },textConstants.UNDO_SHARE_FORM);
        });


    }

    shareFormAPICall(params){
        return restService.shareForm(params).then( data => {
            let sharedGroupId = params.itemId && params.itemId.includes(params.formId) ? params.itemId : constants.DEFAULT_GROUP_ID;
            this.model.set('sharedGroupId',sharedGroupId);
            if(!params.isPrivate) {
                eventBus.trigger('shareForm', params.formId, constants.FORMS_SHARED_GROUP_TYPE, params.itemId, data.GroupId, data.Name);
            }else{
                eventBus.trigger('unShareForm', params.formId, constants.FORMS_PRIVATE_GROUP_TYPE, params.itemId, sharedGroupId, data.Name);
            }
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            console.log('error ', error);
            return (error);

        });
    }

    // For dynamic enabling, see listener changeVersion(ev)
    // This method seems to be called once-only, during first display of this view.
    // That means only the case 'latest' ever executes because the first render always has that
    // radiobutton selected.
    // In other words, almost 2/3 of this method is dead code. - Lou Mauget, 2018-04-18
    // But, the mission here, overlaps much of event-handler, changeVersrion(event). Would be
    // easier to reason about if we could have it delegate here or to have each delegate to a
    // common helper.
    enableButtons() {
        // PF-4409 Reset to from known state:
        (() => {
            $('#publishForm').prop('disabled', false);
            $('#newInstanceForm').prop('disabled', false);
            $('#linkForm').prop('disabled', false);
        })();

        if (this.model.get('groupType') === constants.FORMS_SHARED_GROUP_TYPE) {
            $('#shareForm').text('Unshare');
        }

        const selectedVersion = this.model.get('version');
        // This method only invoked for intial view, which defaults to latest. Assert it anyway.
        if (selectedVersion === 'latest') {
            if ( !this.model.has('publishedVersion') ) {
                $('#publishForm').prop('disabled', false);
                $('#linkForm').prop('disabled', true);
            } else {
                const drafVersion = isNaN(parseFloat(document.getElementById("draftVersion").value)) ? 0 :parseFloat(document.getElementById("draftVersion").value) ;
                const publishedVersion = isNaN(parseFloat(document.getElementById("publishedVersion").value)) ? 0 : parseFloat(document.getElementById("publishedVersion").value) ;
                if( publishedVersion > drafVersion || drafVersion === 0){
                    $('#publishForm').prop('disabled', true);
                }else{
                    $('#publishForm').prop('disabled', false);
                }
                
                $('#linkForm').prop('disabled', false);
            }
        }

        // When owner is other than logged user, then disable buttons Unshare/Share, Migrate and Delete per Sorin's note on PF-2307        
        if  (!FormDetailsView.isUserTheOwner(this.model)){
            FormDetailsView.disableAdminButtons(this.model);
        }

        // PF-9553 Validate if is a trial account to disable link button
        let isTrial = restService.getProfile().IsTrial;
        this.model.set('isTrial', isTrial, {silent: true}); 

    }


    migrateForm(e){
        e.preventDefault();
        let versionList = this.model.get('versionList') instanceof Array?
                            this.model.get('versionList') : [this.model.get('versionList')];
        let versions = [];
        for (let version of versionList) {
            let versionString =version['@MajorVersion']+'.'+version['@MinorVersion'];
            versions.push(versionString);
        }

        const isPrivate = util.isTrue(this.model.get('IsPrivate')) ;
        const migrateFormModal = new MigrateFormModal({model: new Model({
            // Enable transfer ownership option if details are for a shared form
            isPrivate: isPrivate,
            versions: versions })
        });
        migrateFormModal.render().then(importStyle => {
            if(importStyle && importStyle !== 'Unauthorized'){
                let type = null;
                let formId = null;
                let name = this.model.get('formName');
                let ext = null;

                switch (importStyle.selection) {
                    case 'i':
                        this.importFormStyle();
                        break;
                    case 'n':
                        formId = this.getVersionId(importStyle.options);
                        type = 'n';
                        name = name + ' (App).pa';
                        this.exportFormVersion(formId, type, name);
                        break;
                    case 'x':
                        formId = this.model.get('formId');
                        type = this.getType('x', importStyle.options);
                        ext = '.xml';
                        if (type.indexOf('z')>=0 || type.indexOf('a')>=0 ) {
                            ext = '.zip';
                        }
                        this.exportFormVersion(formId, type, name+ext);
                        break;
                    case 's':
                        type = this.getType('s', importStyle.options);
                        formId = this.model.get('formId');
                        ext = '.csv';
                        if (type.indexOf('z')>=0 || type.indexOf('a')>=0 ) {
                            ext = '.zip';
                        }
                        this.exportFormVersion(formId, type, name+ext);
                        break;
                    case constants.DASHBOARD_XFER_OWNERSHIP:
                        this.chooseOwner();
                        break;
                }
            } else {
                notificationService.info( `Migration canceled.`);
            }
        });

    }

    //===========================================================================================================
    // Obtains a transfer-of-ownership destination user choice from the dashboard UI operator. If user chosen,
    // transfers form ownership to that user.
    //===========================================================================================================
    chooseOwner() {
        const formId = this.model.get('formId');
        FormDetailsView.displayUserSelectionModal().then(user => {
            // TODO remove log
            console.log(`transfer form ${this.model.get('formId')} ownership to user ${user.id}`);

            restServiceAux.transferFormOwner(this.model.get('formId'), user.id).then( result => {
                console.log(result);
                notificationService.success( `Ownership transferred to ${user.label}` );
                window.setTimeout(() => eventBus.trigger(constants.EV_UPDATE_FORM_DETAILS, formId), 0);
            }, msg => {
                console.log(msg);
                notificationService.warning( msg );
            });

        }, reason => {
            console.log(reason);
            notificationService.info( `Ownership transfer canceled.` );
        });
    }

    //===========================================================================================================
    // Returns a promise of a chosen ownership transfer target user. This implmentation presents a dialog list
    // of all human users (not groups, etc). If the dialog invoker chooses a user, resolve the promise to the
    // chosen user. Otherwise reject the promise. A caller would probably silently ignore the rejection.
    // (Reused statically by ReportDetailsView)
    //===========================================================================================================
    static displayUserSelectionModal() {
        return new Promise((resolve, reject) => {
            if (!this.Spinner){
                this.Spinner = new Spinner();
            }
            this.Spinner.spin($(constants.CONTENT_ID).get(0));
            setTimeout(() => {
                restService.browseAllUsers().then(userData => {
                    const users = userData.AllUsers.User ? util.enforceArrayType(userData.AllUsers.User) : [];
                    let items = [];
                    users.forEach(user => {                            
                        if (user['@type'] === 'user'){
                            items.push({ 
                                label: user['@caption'],
                                listType: 'user',
                                items: user
                            });
                        }
                    });
                    const alertView = new SelectItemModalView({ model: new Model({ items: items, subtitle: 'Select User' }), spinner: this.Spinner });

                    alertView.render().then(selectedItemInModal => {
                        if (selectedItemInModal) {
                            const userChosen = {
                                option: 'user',
                                label: selectedItemInModal.label,
                                data: selectedItemInModal.items,
                                id: selectedItemInModal.items['@id']
                            };
                            resolve(userChosen);
                        } else {
                            reject('nothing-chosen');
                        }
                    }, err => console.log(`Error choosing new owner user`, err));
                });
            });
        }, 10);
    }

    importFormStyle(){
        const selectFileModal = new SelectFileModal();
        selectFileModal.render().then(selectedFile => {
            if (selectedFile && selectedFile !== 'Unauthorized'){
                this.importWithFile(selectedFile);
            }
        });
    }

    importWithFile(file){
        const formId = this.model.get('formId');
        let groupType = this.model.get('groupType');
        let groupId = this.model.get('groupId');
        restService.importFormStyle(formId, file.name, file.file).then((result) => {
            const selectFileModal = new SelectFileModal({title: 'Import', itemName: result.Import.Item['@caption'], dependencies: 'None'});
            selectFileModal.render().then(selectedFile => {
                // reloading the form to show the new version
                eventBus.trigger('deployForm', formId, groupType, groupId);
            });
        }, ( errMsg ) =>{
            
            if (errMsg.CODE === '999') {
                const content = 'The selected file type is not supported. ' + 
                                'Apps and reports created in 4.x or earlier versions cannot be imported currently.';
                const selectFileModal = new SelectFileModal({title: 'Import', 
                        itemName: content, dependencies: 'None',
                        width: 450, 
                        message: "Import Failed."
                    });
                selectFileModal.render().then(selectedFile => {
                    // no actions required.
                });

                notificationService.error('File was not imported succesfully');
            } 
            else {
                notificationService.error( errMsg );
            }
        });
    }

    exportFormVersion(formId, type, name){
        console.log('formId, type, name', formId, type, name);
        if (formId !== null) {
            restService.exportFormResponseData(formId, type, name);
        } else {
            notificationService.error( 'No version found' );
        }
    }

    getVersionId(version){
        let versionArray = version.split('.');
        let id = null;
        let versionList = this.model.get('versionList');

        if (versionList instanceof Array){
            let i = 0;
            do {
                let version = versionList[i];
                if (version['@MajorVersion'] === versionArray[0] && version['@MinorVersion'] === versionArray[1] ) {
                    id = version['@FormVersionId'];
                }
                ++i;
            } while (!id || i< versionList.length);
        } else {
            if (versionList['@MajorVersion'] === versionArray[0] && versionList['@MinorVersion'] === versionArray[1] ) {
                id = versionList['@FormVersionId'];
            }
        }
        return id;
    }

    getType(selection, options){
        let type = '';
        if (options.length <= 0 ){
            type = selection;
        } else {
            switch (selection) {
                case 'x' :
                    if ($.inArray('z', options) >= 0) {
                        type = 'z';
                    }
                    if ($.inArray('a', options) >= 0) {
                        type = 'a';
                    }
                    type = type + 'x';
                    break;
                case 's':
                    if ($.inArray('z', options) >= 0) {
                        type = 'z';
                    }
                    if ($.inArray('a', options) >= 0) {
                        type = 'a';
                    }
                    if ($.inArray('h', options) >= 0) {
                        type = type + 'h';
                    }
                    if ($.inArray('ss', options) >= 0) {
                        type = type + 'ss';
                    } else if ($.inArray('ts', options) >= 0) {
                        type = type + 'ts';
                    } else {
                        type = type + 'cs';
                    }
                    break;
            }
        }
        return type;
    }

    disablePublishingOptions() {
        switch (this.model.get('version')) {
            case 'latest':
                $(`select[name='publishedVersion']`).prop('disabled', true);
                $(`select[name='draftVersion']`).prop('disabled', true);
                $('input[value="latest"]').prop('checked', true);



                break;
            case 'deployed':
                $(`select[name='publishedVersion']`).prop('disabled', false);
                $(`select[name='draftVersion']`).prop('disabled', true);
                $('input[value="published"]').prop('checked', true);
                break;
            case 'draft':
                $(`select[name='deployVersion']`).prop('disabled', true);
                $(`select[name='draftVersion']`).prop('disabled', false);
                $('input[value="draft"]').prop('checked', true);
                break;
        }
    }

    // PF-4409
    // This method governs enabling of the Publish button as a function of the selected published
    // version. Note that the enableButtons method is only called once, to statically set
    // selections and button conditioning. This method is called at each selection of draft or
    // publised RBs.
    selectVersion(ev) {
        ev.preventDefault();
        const name = ev.target.name;
        let disablePublish = true;
        if (name !== 'publishedVersion') {
            const latestVersion = this.model.get('latestVersion');
            const propVal = ev.target.value;
            disablePublish = propVal !== latestVersion;
            this.model.set(name, propVal, { silent: true });
        }

        $('#publishForm').prop('disabled', disablePublish);
    }

    handleSelectedItem(ev){
        ev.preventDefault();
        //Starting spinner, each eventBus.trigger event invoked should be responsible to shut the spinner down
        let spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        const itemId = ev.currentTarget.attributes['data-itemid'].value;
        const gui = ev.currentTarget.attributes['data-guid'].value;
        const type = ev.currentTarget.attributes['data-type'].value;
        
        if(type === 'form'){
            eventBus.trigger('newInstance', itemId);
        }else if(type === 'report'){
            eventBus.trigger('loadReportsView');
            setTimeout(() => {
                eventBus.trigger('relatedReport', itemId);
            }, 500);
        }else if(type === 'connection'){
            eventBus.trigger('loadConnectionsView');
            setTimeout(() => {
                eventBus.trigger('relatedConnection', gui);
            }, 500);
        }else{
            spinner.stop();
        }
    }

    static isUserFullControl(model) {

        let userHasFullControl = false;
        const currentUserPermission = model.get('userPermissionList');

        let fullControl = _.find(currentUserPermission.User.Permission, (p) => {
            return p["@type"] === "administer" && p["#text"] === "allow";
        });
        if (fullControl) {
            userHasFullControl = true;
        }

        return userHasFullControl;
    }

    static isUserTheOwner( model ) {
        let result = true;
        if (listService.userProfile.UserId) {
            result = listService.userProfile.UserId === model.get('ownerId');
        } else {
            // PF-3612: Request user details to backend again... somehow between browser refresh the details get lost
            restService.getAccountDetails().then((obj)=>{
                result = model.get('ownerId') === obj.AdminUserId;
            });
        }

        return result;
    }

    static disableAdminButtons( model ) {

        const userFull = FormDetailsView.isUserFullControl( model );
        const buttonsToDisable = userFull ? ['shareForm', 'deleteForm'] : ['shareForm', 'migrateForm', 'deleteForm'];

        buttonsToDisable.forEach( id => $(`#${id}`).prop('disabled', true) );

        if(!userFull){
            FormDetailsView.hideAdminSections();
        }
    }

    static hideAdminSections() {
        $('#permissionsSection').addClass('hide');
        //$('#instancesSection').addClass('hide');
        $('input[name="currentFormName"]').prop('disabled', true);
    }

    render() {
        const self = this;
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.$el.css('cursor', 'default');

        // Cleaning select options first.
        $(`select[name='publishedVersion']`).empty();
        $(`select[name='draftVersion']`).empty();
        $(`select[name='permissions']`).empty();

        if (this.model.get('versionList') instanceof Array) {
            // Filling Version Dropdown with the data from the API after rendering.
            for (let version of this.model.get('versionList')) {
                if (version['@MinorVersion'] === '0') {
                    $(`select[name='publishedVersion']`).append($("<option></option>")
                        .attr('value', `${version['@MajorVersion']}.${version['@MinorVersion']}`)
                        .attr('formVersionId', version['@FormVersionId'])
                        .text(`${version['@MajorVersion']}.${version['@MinorVersion']}`));
                }
                else {
                    $(`select[name='draftVersion']`).append($("<option></option>")
                        .attr('value', `${version['@MajorVersion']}.${version['@MinorVersion']}`)
                        .attr('formVersionId', version['@FormVersionId'])
                        .text(`${version['@MajorVersion']}.${version['@MinorVersion']}`));
                }

            }
            if($(`select[name='publishedVersion'] option`).length === 0){
                $(`select[name='publishedVersion']`).prop('disabled', true);
                $(`input[value='published']`).prop('disabled', true);
            }
            if($(`select[name='draftVersion'] option`).length === 0){
                $(`select[name='draftVersion']`).prop('disabled', true);
                $(`input[value='draft']`).prop('disabled', true);
            }

        }
        else {
            if(!this.model.get('publishedVersion')){
                $(`select[name='draftVersion']`).append($("<option></option>")
                .attr('value', `${this.model.get('versionList')['@MajorVersion']}.${this.model.get('versionList')['@MinorVersion']}`)
                .attr('formVersionId', this.model.get('versionList')['@FormVersionId'])
                .text(`${this.model.get('versionList')['@MajorVersion']}.${this.model.get('versionList')['@MinorVersion']}`));
            }else{
                $(`select[name='publishedVersion']`).append($("<option></option>")
                .attr('value', `${this.model.get('versionList')['@MajorVersion']}.${this.model.get('versionList')['@MinorVersion']}`)
                .attr('formVersionId', this.model.get('versionList')['@FormVersionId'])
                .text(`${this.model.get('versionList')['@MajorVersion']}.${this.model.get('versionList')['@MinorVersion']}`));
            }
          
                        
            $(`select[name='publishedVersion']`).prop('disabled', true);
            $(`input[value='published']`).prop('disabled', true);
            $(`select[name='draftVersion']`).prop('disabled', true);
            $(`input[value='draft']`).prop('disabled', true);
        }

        // Filling Permission Dropdown with the data from the API after rendering.
        this.model.get('currentPermissionList').forEach( permission => {
            $(`select[name='permissions']`).append($("<option></option>")
                .attr('id', permission['@id'])
                .attr('value', permission['@caption'])
                .text(permission['@caption']));
        });

        if (!util.isTrue( this.model.get('IsPrivate') )) {
            $('#sharedPermissions').removeClass('hide');
            $('#shareForm').html('Unshare');

            this.permsDetailView = new PermissionsDetailView({model: this.model, el: '#sharedPermissions', 'isReport': false});
            this.permsDetailView.render();
        }

        $('input[value="' + this.model.get('version') + '"]').attr('checked', true);

        let currentRequireLoginFromEmail = util.isTrue(this.model.get('currentRequireLoginFromEmail'));
        $(`input[name='currentRequireLoginFromEmail']`).prop('checked', currentRequireLoginFromEmail );


        this.disablePublishingOptions();
        this.enableButtons();

        if (this.model.get('hasChanges')) {
            $('#formActionSection').addClass('hide');
            $('#formPermissionSection').removeClass('hide');

            $('input[name="currentFormName"]').trigger('focus').val("").val(this.model.get('currentFormName'));
        }


        const $perms = $(this.permsSelector);
        const permHandler = function () {

            const
                isReport = false,
                selectedUser = $(this).val() || '',
                selectedUserId = $(this).children(':selected').attr('id'),
                fullControlIdPrefix = constants.FORMS_FULL_CONTROL_PERM_DATA_INDEX;

            self.renderSelectedViewerLabel(selectedUserId, selectedUser);

            const permission = PermissionsDetailView.selectedViewerPerms(selectedUserId, selectedUser, self.model.get('currentPermissionList'));
            self.model.set('currentViewerPerms', permission, {silent: false});

            // console.log(`${selectedUser} ${selectedUserId}`);

            // Set dropdown selection to render selected visual

            // World and Everyone have same ID! We're lucky that they don't have dupe captions as normal entries could
            if ('World' === selectedUser || 'Everyone' === selectedUser) {
                $(`select[name='permissions'] option[value='${selectedUser}']`).attr('selected', 'selected');
            } else {
                $(`select[name='permissions'] option[id='${selectedUserId}']`).attr('selected', 'selected');
            }

            // Encapsulate setting special Full Control UI behavior if either Full Control option set
            (() => {
                const isEitherFullControlChecked
                    = $(`#${fullControlIdPrefix}allow`).prop('checked')
                    || $(`#${fullControlIdPrefix}deny`).prop('checked');
                PermissionsDetailView.disableNormalRows(isEitherFullControlChecked, isReport);
            })();

            PermissionsDetailView.conditionWorldPermUI(selectedUser, permission.length);

        };
        $perms.off('change');
        $perms.on('change', permHandler);

        this.delegateEvents();
        return this;
    }

    renderSelectedViewerLabel(selectedViewerId, selectedViewer ){
        this.model.set( {
            'selectedViewer': selectedViewer,
            'selectedViewerId': selectedViewerId
        }, {silent: true});

    }

    refresh(){
        $(this.permsSelector).off('change');
        this.cancelChanges();

        // Find current form ID
        const formId = listService.dashboardLayout.leftPanelView.detailView.model.get('formId');
        eventBus.trigger('newInstance', formId);
        if(this.model.get('hasChanges')){
            
            let simpleModal=new SimpleConfirmModalView({
                model:new Model({subtitle:`App - ${this.model.get("formName")}`,
                    confirmationText:`Are you sure you want to refresh this page?\r All changes made on the current page will be lost.`,
                    height:200,
                    width:400})
            });
            simpleModal.render().then((result)=>{
                if (result === 'Ok') {
                    eventBus.trigger(constants.EV_UPDATE_FORM_DETAILS, this.model.get('formId'));
                }
            }).catch((err)=> {
                console.log('Error Showing Refresh Confirmation Message', err);
                NotificationService.error('Error Showing Refresh Confirmation Message' + err.MESSAGE);
            });
        }
        else{
            eventBus.trigger(constants.EV_UPDATE_FORM_DETAILS, this.model.get('formId'));
        }
    }

    goToForms(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger("loadFormsView");
    }

    goToEditForms(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger("displayDefaultEditFormsDetailView");        
    }
}

export default FormDetailsView;

